import { ArrowsClockwise, CheckCircle, Database, X } from "@phosphor-icons/react";
import { useState } from "react";
import { useSavedLibrary } from "../../lib/saved-library";

export function GuestLibraryImportBanner() {
  const {
    mode,
    mutating,
    guestImport,
    importGuestData,
    dismissGuestImport
  } = useSavedLibrary();
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");

  if (mode !== "account" || ((!guestImport.pending || guestImport.dismissed) && !notice)) {
    return null;
  }

  async function runImport() {
    setError("");
    try {
      const result = await importGuestData();
      const mergedCount = result.mergedSpotCount + result.mergedSearchCount;
      setNotice(
        `${mergedCount} device ${mergedCount === 1 ? "item was" : "items were"} merged into your account.${result.skippedSpotCount ? ` ${result.skippedSpotCount} demonstration ${result.skippedSpotCount === 1 ? "Spot stays" : "Spots stay"} on this device.` : ""}`
      );
    } catch (caughtError) {
      setError(caughtError instanceof Error ? caughtError.message : "Device saves could not be imported.");
    }
  }

  if (notice) {
    return (
      <section className="guest-import-banner complete" role="status">
        <CheckCircle size={22} weight="fill" aria-hidden="true" />
        <span>{notice}</span>
        <button type="button" aria-label="Dismiss import confirmation" onClick={() => { setNotice(""); dismissGuestImport(); }}>
          <X size={18} weight="bold" aria-hidden="true" />
        </button>
      </section>
    );
  }

  const importableCount = guestImport.importableSpotCount + guestImport.searchCount;
  return (
    <section className="guest-import-banner" aria-labelledby="guest-import-title">
      <Database size={24} weight="duotone" aria-hidden="true" />
      <div>
        <strong id="guest-import-title">Bring your device saves into this account?</strong>
        <span>
          {importableCount
            ? `${guestImport.importableSpotCount} saved ${guestImport.importableSpotCount === 1 ? "Spot" : "Spots"} and ${guestImport.searchCount} saved ${guestImport.searchCount === 1 ? "search" : "searches"} can sync across devices.`
            : `${guestImport.skippedSpotCount} demonstration ${guestImport.skippedSpotCount === 1 ? "Spot is" : "Spots are"} device-only and cannot be imported.`}
          {guestImport.skippedSpotCount && importableCount
            ? ` ${guestImport.skippedSpotCount} demonstration ${guestImport.skippedSpotCount === 1 ? "Spot will" : "Spots will"} stay on this device.`
            : ""}
        </span>
        {error ? <small role="alert">{error}</small> : null}
      </div>
      <div className="guest-import-actions">
        {importableCount ? (
          <button type="button" className="button primary" disabled={mutating} onClick={() => void runImport()}>
            <ArrowsClockwise size={17} weight="bold" aria-hidden="true" />
            {mutating ? "Importing" : "Import to account"}
          </button>
        ) : null}
        <button type="button" className="button secondary" disabled={mutating} onClick={dismissGuestImport}>
          {importableCount ? "Not now" : "Dismiss"}
        </button>
      </div>
    </section>
  );
}
